export const refireNonComposableNativeEvents = (event: Event, host: HTMLElement): void => {
  if (event.composed) return;
  /*                                                        */
  const canceled = host.dispatchEvent(new event.constructor(event.type, event));
  if (canceled) event.preventDefault();
};
